import compose from 'utilities/compose';
import withAppBar from './withAppBar'
import withContainer from './withContainer'

export default (options) => compose(
  withAppBar(options),
  withContainer,
)
